export default "__VITE_ASSET__DMsY9AJO__"